export enum AddEditAction {
  Add,
  Edit,
}

export enum ToolbarItemType {
  Accept,
  Cancel,
  Add,
  Edit,
  Remove,
  Print,
  Filter,
  Info,
}

export enum MessageStyle {
  Standard,
  Information,
  Warning,
  Error,
  Success,
}

export enum MessageType {
  Default,
  Confirmation,
}

export enum MessageResult {
  Accept,
  Cancel,
  Continue,
}
